import Vue from "vue"
import router from "@/router"
import { make } from "vuex-pathify"
import { Toast } from "buefy/dist/components/toast"
import AuthProxy from "@/proxies/AuthProxy"
import AccountProxy from "@/proxies/AccountProxy"

const state = {
  authenticated: false,
  account: {
    email: null,
    id: null,
    username: null
  }
}

const mutations = make.mutations(state)

const actions = {
  check({ commit, state }) {
    commit("SET_AUTHENTICATED", !!localStorage.getItem("id_token"))
    if (state.authenticated) {
      Vue.$http.defaults.headers.common.Authorization = `Token ${localStorage.getItem(
        "id_token"
      )}`
    }
  },

  async find({ commit }) {
    try {
      let response = await new AccountProxy().all()
      commit("SET_ACCOUNT", response)
    } catch (error) {
      alert("Il server backend non risponde.")
      localStorage.removeItem("id_token")
      router.push({
        name: "login"
      })
    }
  },

  async login({ dispatch, commit }, payload) {
    try {
      let response = await new AuthProxy().login(payload)
      commit("SET_AUTHENTICATED", true)
      localStorage.setItem("id_token", response.auth_token)
      Vue.$http.defaults.headers.common.Authorization = `Token ${
        response.auth_token
      }`
      Toast.open({
        message: "Login effettuato con successo",
        type: "is-success"
      })
      await dispatch("find")
      router.push({
        name: "home"
      })
    } catch (error) {
      console.log(error)
      Toast.open({
        message: "Credenziali non valide",
        type: "is-danger"
      })
    }
  },

  logout({ commit }) {
    commit("SET_AUTHENTICATED", false)
    localStorage.removeItem("id_token")
    Vue.$http.defaults.headers.common.Authorization = ""
    router.push({
      name: "login"
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
